import { render, staticRenderFns } from "./HomeAdmin.vue?vue&type=template&id=8ffd12aa&scoped=true"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"
import style0 from "./HomeAdmin.vue?vue&type=style&index=0&id=8ffd12aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd12aa",
  null
  
)

export default component.exports